export const categories = [
  { id: 'yiqu-erqu', name: '一区二区', slug: 'yiqu-erqu', description: '最新爆料一区二区内容，高清视频在线播放' },
  { id: 'zaixian-guankan', name: '在线观看', slug: 'zaixian-guankan', description: '黑料吃瓜网在线观看专区，免费高清完整视频' },
  { id: 'zhan-guankan', name: '站在线观看', slug: 'zhan-guankan', description: '黑料吃瓜网站在线观看资源，即点即播' },
  { id: 'zuixin-baoliao', name: '最新爆料', slug: 'zuixin-baoliao', description: '最新娱乐圈爆料吃瓜资讯，一手消息抢先看' },
  { id: 'mingxing-bagua', name: '明星八卦', slug: 'mingxing-bagua', description: '明星娱乐圈八卦新闻，热门话题追踪' },
  { id: 'shehui-redian', name: '社会热点', slug: 'shehui-redian', description: '社会热点事件追踪，深度解读热门话题' },
];

export const hotTags = [
  '一区二区', '在线观看', '免费观看', '完整视频', '高清资源',
  '明星八卦', '最新爆料', '吃瓜', '站在线观看', '网红',
  '娱乐圈', '热门事件', '独家', '实时更新',
];